<div class="m-b-20" *ngIf="uiConfig && uiConfig['allowSearchAdd'] == 'BOTH'">
    <nz-radio-group [(ngModel)]="chooseToAddClientBy" nzButtonStyle="solid">
        <label nz-radio-button nzValue="SEARCH">
            <i nz-icon nzType="user" nzTheme="outline"></i> Search {{captureRole | technicalTranslate}}
        </label>
        <label nz-radio-button nzValue="ADD">
            <i nz-icon nzType="file-protect" nzTheme="outline"></i> Add New {{captureRole | technicalTranslate}}
        </label>
    </nz-radio-group>
</div>

<ng-container *ngIf="chooseToAddClientBy == 'ADD';else showBySearch">

    <div class="grid grid-gap-20 grid-4x m-t-b-20">
        <nz-form-item class="reset-m-force">
            <nz-form-label [nzSpan]="24" nzFor="clientTypeCd">Client Type</nz-form-label>
            <nz-form-control [nzSpan]="24">
                <nz-select [(ngModel)]="clientTypeCd" style="width: 100%">
                    <nz-option *ngFor="let item of (lookup$[uiConfig['clientTypeLookupCd']] | async);"
                        [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>
    </div>

    <ng-container [ngSwitch]="clientTypeCd">
        <div *ngSwitchCase="'PERSON'">
            <app-dynamic-form FORMTITLE="" [FORMNAME]="uiConfig.personFormConfig.controlId" [maxDepth]="4"
                ExtractElementFromArray="true" [currentComponentName]="uiConfig.personFormConfig.controlId"
                [IO]="_clientDataObj" [baseDOName]="baseDOname"
                [(ngModel)]="currentAllDynamicComponentData[clientTypeCd]" [dynamicRenderingMode]="true"
                [formMetaData]="uiConfig.personFormConfig.formItems">
            </app-dynamic-form>
        </div>

        <div *ngSwitchCase="'ORGANIZATION'">
            <app-dynamic-form FORMTITLE="" [FORMNAME]="uiConfig.organizationFormConfig.controlId" [maxDepth]="4"
                ExtractElementFromArray="true" [currentComponentName]="uiConfig.organizationFormConfig.controlId"
                [IO]="_clientDataObj" [baseDOName]="baseDOname"
                [(ngModel)]="currentAllDynamicComponentData[clientTypeCd]" [dynamicRenderingMode]="true"
                [formMetaData]="uiConfig.organizationFormConfig.formItems">
            </app-dynamic-form>
        </div>

        <div *ngSwitchDefault>
            <span nz-typography nzType="danger">Requested form is not configured. Please try again later or contact your
                system administrator.</span>
        </div>
    </ng-container>


    <div *ngIf="uiConfig?.captureContactDetails">
        <div class="heading-tab m-t-15">
            <h3 class="heading">
                <i nz-icon nzType="solution" nzTheme="outline" class="m-r-5"></i> <span translate>Contact Details</span>
            </h3>
        </div>

        <div class="flexie-auto-grid">
            <!-- Email -->
            <div class="flex-self-vert-start">
                <h4>
                    <i nz-icon nzType="mail" nzTheme="outline" class="m-r-5"></i> <span translate>Email</span>
                </h4>
                <ui-multirow-basic (componentOutput)="fetchEmailList($event)" type="email"
                    [inputDataForEdit]="inputClientCaptureEmailDetailsList"></ui-multirow-basic>
            </div>

            <!-- Mobile -->
            <div class="flex-self-vert-start">
                <h4>
                    <i nz-icon nzType="mobile" nzTheme="outline" class="m-r-5"></i> <span translate>Mobile</span>
                </h4>
                <ui-multirow-basic (componentOutput)="fetchPhoneList($event)" type="phone"
                    [inputDataForEdit]="inputClientCapturePhoneDetailsList"></ui-multirow-basic>
            </div>
        </div>
    </div>

    <div *ngIf="uiConfig?.captureAddressDetails">
        <div class="heading-tab m-t-15">
            <h3 class="heading">
                <i nz-icon nzType="home" nzTheme="outline" class="m-r-5"></i> <span translate>Address Details</span>
            </h3>
        </div>
        <ui-address-ind (componentOutput)="fetchAddressList($event)"
            [inputDataForEdit]="inputClientCaptureAddressDetailsList"></ui-address-ind>
    </div>

    <div *ngIf="uiConfig?.captureIdentityDetails">
        <div class="heading-tab m-t-15">
            <h3 class="heading">
                <i nz-icon nzType="idcard" nzTheme="outline" class="m-r-5"></i> <span translate>Identity Details</span>
            </h3>
        </div>

        <app-identity-capture (componentOutput)="fetchIdentityList($event)"
            [inputDataForEdit]="inputClientCaptureIdentityDetailsList"></app-identity-capture>
    </div>

    <div class="add-client-footer">
        <button nz-button [nzType]="'primary'" (click)="addUpdateClientData()">Add</button>
    </div>

</ng-container>


<ng-template #showBySearch>
    <div style="max-width: 800px;">
        <app-ui-search [SearchCriteria]="CRITERIALOOKUP" (componentOutput)="fetchClientResult($event)"
            [searchURL]="uiConfig?.searchConfig?.searchURL" [itemsPerPage]='uiConfig?.searchConfig?.itemsPerPage'>
        </app-ui-search>
    </div>

    <nz-table *ngIf="searchedClientList && searchedClientList.length > 0 && uiConfig?.searchConfig?.searchTableHeaders"
        #searchedResultTable [nzData]="searchedClientList" [nzSize]="'middle'" class="m-t-20">
        <thead>
            <tr>
                <th scope="col" nzWidth="60px"></th>
                <!--This empty header is for checkbox used for selection of row-->
                <ng-container *ngFor="let config of uiConfig.searchConfig.searchTableHeaders;let index = i">
                    <th scope="col">{{config.header}}</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of searchedResultTable.data">
                <td [nzChecked]="setOfCheckedId.has(data[keyForSelectingData])"
                    (nzCheckedChange)="rowSelectionStatusChanged($event, data[keyForSelectingData])"></td>
                <ng-container *ngFor="let config of uiConfig.searchConfig.searchTableHeaders;let index = i">
                    <td>
                        <ng-container [ngSwitch]="config.pipe">
                            <span *ngSwitchCase="'technicalTranslate'">{{data[config.key] | technicalTranslate}}</span>
                            <span *ngSwitchCase="'date'">{{ getDateString(data[config.key])}}</span>
                            <span *ngSwitchCase="'currencyFormatter'">{{data[config.key] | CurrencyFormatter}}</span>
                            <span *ngSwitchDefault>{{ data[config.key] || '-' }}</span>
                        </ng-container>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </nz-table>

    <div class="add-client-footer" *ngIf="searchedClientList && searchedClientList.length > 0">
        <button nz-button nzType="primary" (click)="emitSelectedClient()"
            [disabled]="selectedListOfClientData.length == 0">Proceed</button>
    </div>
</ng-template>